import { Icon } from "atoms/icon/Icon";

import InfoIcon from "../icon/icons/info.svg";

type RepeatCashBannerProps = {
  message: string;
};
const RepeatCashAvailabilityBanner = ({ message }: RepeatCashBannerProps) => {
  return (
    <div className="mt-5">
      <div className="items-center rounded bg-background-two py-2.5">
        <div className="flex items-center">
          <div className="pl-3">
            <Icon svg={InfoIcon} size="xsmall" color="secondaryText" />
          </div>
          <div className="flex flex-col">
            <div className="pl-3 pr-4 text-body2">
              <span className="text-bold2">RepeatCash</span> {message}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepeatCashAvailabilityBanner;
